module.exports = __webpack_public_path__ + "img/hotel.150e2906.jpg";